// client/components/ui/ResponsiveFormLayout.jsx
import React from "react";
import { twMerge } from "tailwind-merge";
import { mobileOverflowGuardClassName } from "../../design/tokens.js";

const COLS_CLASS = {
  1: "grid-cols-1",
  2: "grid-cols-1 md:grid-cols-2",
  3: "grid-cols-1 md:grid-cols-3",
};

/**
 * ResponsiveFormLayout — Formular-Raster: einspaltig Mobile, md+ wie bisheriges 2/3-Spalten-Grid.
 */
export default function ResponsiveFormLayout({
  children,
  className = "",
  cols = 2,
  gapClassName = "gap-3",
}) {
  const gridCols = COLS_CLASS[cols] || COLS_CLASS[2];

  return (
    <div
      className={twMerge(
        "grid min-w-0",
        gridCols,
        gapClassName,
        mobileOverflowGuardClassName,
        className,
      )}
    >
      {children}
    </div>
  );
}
